export default {
	data() {
		return {
			initial: {
				geturl: "",
				config:{
					page: 1,
					limit: 10,
				}
			}

		}
	},
	methods: {
		getData(params) {
			var config  =this.initial.config;
			var PageParams={};
			if(Object.keys(params).length){
				var PageParams=params;
			}
      console.log(PageParams,"PageParams")
			var target=Object.assign(config,PageParams);
			return new Promise((resolve, reject) => {
				this.axios.post(this.initial.geturl, target).then(res => {
					resolve(res)
				}).catch(err => {

				})
			})
		},
		SizeChange(e) {
			this.initial.config.limit = e.size;
			this.initial.config.page = e.page;
			this.jiazai()
		},
		CurrentChange(e) {
      console.log(e,111)
			this.initial.config.limit = e.size;
			this.initial.config.page = e.page;
			this.jiazai()
		},
	}


}



// WEBPACK FOOTER //
// ./src/components/base/basePagination/controls.js